module.exports = __webpack_public_path__ + "static/media/Kingdom.6ae71570.png";